import cn from 'classnames'
import React from 'react'
import config from '../../config.json'
import Button from '../common/util/input/Button'
import Page from '../page/Page'
import SearchComponent from '../searchitems'
import { useSharedState } from '../waxplorer/Waxplorer'

export const Bulk = (props) => {
    const [state, , { login }] = useSharedState()

    const activeUser = state?.activeUser

    const userName = activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const collectionDetails = props['collection_details']
    const collectionName = collectionDetails ? collectionDetails['name'] : null

    const title = config.titles.bulk.replace(
        '{collectionName}',
        collectionName ? collectionName : 'WAX.io',
    )
    const description = config.descriptions.bulk.replace(
        '{collectionName}',
        collectionName ? collectionName : 'WAX.io',
    )

    return (
        <Page
            id={'BulkPage'}
            title={title}
            description={description}
            banners={false}
            {...props}
        >
            {!userName ? (
                <div className={'p-8'}>
                    <div className={cn('text-neutral')}>
                        In order to use the NFTHive Bulk Tools to Sell and
                        Transfer NFTs, Edit and Push Listings, click:
                    </div>
                    <Button
                        className={'font-bold md:font-semibold text-xl'}
                        onClick={() => login()}
                    >
                        Login
                    </Button>
                </div>
            ) : (
                <SearchComponent
                    {...props}
                    bulk={true}
                    searchSettings={{
                        limit: { value: 50, fixed: false },
                        expanded: false,
                    }}
                />
            )}
        </Page>
    )
}
